import NewFrom from "csi/action/NewFrom";
import LocaleResolver from "csi/config/LocaleResolver";
import ReflectionClass from "csi/reflection/ReflectionClass";
import { C8Node } from "csi/typings";
import declare from "dojo/_base/declare";

const NewFromPartMaterialAction = declare(NewFrom, {
	resolve(lr: LocaleResolver, rcRoot: ReflectionClass, nodeRoot: C8Node) {
		this.m_typeNodeHint = rcRoot.getMasterClass().type;
		this.inherited(arguments);
	},
});

export = NewFromPartMaterialAction;
